export const whenSidebarFits = 'min-width: 1056px'
